<template>
  <nav
    v-if="hasInsights || hasParticipants || hasUrbanVision"
    :class="$style.root"
  >
    <div :class="$style.content">
      <pages-editions-slug-nav-item-component
        v-for="(linkObject, index) in linkObjects"
        :key="index"
        :route-name="linkObject.routeName"
        :label="linkObject.label"
        :slug="slug"
        :class="$style.item"
      />
    </div>
  </nav>
</template>

<script lang="ts" setup>
const route = useRoute()
const router = useRouter()
const localePath = useLocalePath()
const nuxtApp = useNuxtApp()
const { $i18n } = nuxtApp

const props = defineProps({
  hasInsights: {
    type: Boolean,
    default: false
  },
  hasParticipants: {
    type: Boolean,
    default: false
  },
  hasUrbanVision: {
    type: Boolean,
    default: false
  },
  hasEducation: {
    type: Boolean,
    default: false
  },
  slug: {
    type: String,
    required: true
  }
})

const linkObjects = [
  {
    include: true,
    routeName: 'editions-slug-index-about',
    label: $i18n.t('editionsSlug.navAbout')
  },
  {
    include: props.hasUrbanVision,
    routeName: 'editions-slug-index-urban-vision',
    label: $i18n.t('labels.urbanVision')
  },
  {
    include: props.hasEducation,
    routeName: 'editions-slug-index-education',
    label: $i18n.t('labels.education')
  },
  {
    include: props.hasInsights,
    routeName: 'editions-slug-index-insights',
    label: $i18n.t('editionsSlug.navInsights')
  },
  {
    include: props.hasParticipants,
    routeName: 'editions-slug-index-participants',
    label: $i18n.t('labels.participant', {count: 2})
  }
].filter(i => i.include === true)

const isEditionsSlugIndexInsights = computed(() => getRouteName() === 'editions-slug-index-insights')
const isEditionsSlugIndexParticipants = computed(() => getRouteName() === 'editions-slug-index-participants')
const isEditionsSlugIndexUrbanVision = computed(() => getRouteName() === 'editions-slug-index-urban-vision')
const isEditionsSlugIndexEducation = computed(() => getRouteName() === 'editions-slug-index-education')

const pushToAboutPage = () => {
  const path = localePath({ name: 'editions-slug-index-about', props: { slug: route?.params?.slug } })
  router.push(path)
}

if (isEditionsSlugIndexInsights.value && !props.hasInsights) {
  pushToAboutPage()
}
else if (isEditionsSlugIndexParticipants.value && !props.hasParticipants) {
  pushToAboutPage()
}
else if (isEditionsSlugIndexUrbanVision.value && !props.hasUrbanVision) {
  pushToAboutPage()
}
else if (isEditionsSlugIndexEducation.value && !props.hasEducation) {
  pushToAboutPage()
}
</script>

<style module>
.root {
  composes: font-size-small container from global;
  user-select: none;
}

.content {
  display: flex;
  justify-content: center;

  flex-wrap: wrap;
  gap: var(--stroke--default);
}

.item {
}
</style>
